module.exports = __webpack_public_path__ + "ae7fe6fc68b073f740176d14f6eaeec6.pdf";